export const accessToken =
    "pk.eyJ1IjoibGl2aW5nZG5hIiwiYSI6ImNqdzdvc2sweTBjMnQzem83ZXJ2aGt3MmYifQ.SuUkU8k0-HgmYqnyZ5KLXQ";
export const mapStyle = "mapbox://styles/livingdna/ck1kvc57t0e321cmkkm80kbmm";

export const vikingAccessToken =
    "pk.eyJ1IjoibWFydGluLWJseXRoZSIsImEiOiJja3gwNzRueDkwcGlwMm9ueTZmM2htaHVqIn0.ZjODz0eE4lIQ5q4BoIuZkg";
export const vikingMapStyle = "mapbox://styles/martin-blythe/cl0jgrzho001714ny9fgam8kh";

// Default autosomal tileset used when a result does not specify its own (e.g. the
// legacy panel). Newer panels — such as the Irish panel upgrade — return their own
// tileset id in the results payload (testData.autosomal.tileset) which takes precedence.
export const defaultTileset = process.env.VUE_APP_MAP_TILESET_URL;

/**
 * Resolves the Mapbox tileset id to render for a result. Prefers the id supplied by the
 * backend (per-panel), falling back to the default env tileset. The tileset id doubles as
 * the vector source-layer name, so callers must use this single value for both the source
 * url and every `source-layer` reference.
 * @param {string} [tileset] tileset id from the results payload
 * @returns {string}
 */
export function resolveTileset(tileset) {
    return tileset || defaultTileset;
}